var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgNotificationShares = function SvgNotificationShares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20z",
    fill: "url(#notificationShares_svg__71l9pbrgka)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.67 20.74l-7.581-7.483a1.027 1.027 0 00-1.71.894v3.942c-6.922.092-12.41 1.676-12.41 9.176a10.512 10.512 0 003.6 7.59.8.8 0 001.2-.918c-1.954-7.14.926-9.036 7.6-9.146v4.33a1.029 1.029 0 001.71.894l7.584-7.484a1.296 1.296 0 00.008-1.794z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "notificationShares_svg__71l9pbrgka",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14 17.28) scale(26.64)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0076FF"
  })))));
};
export default SvgNotificationShares;